<div class="table-responsive" *ngIf="subscriptionGroupList">
  <table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>
      <th>#</th>
      <th>Name</th>
      <th>Description</th>
      <th>Groupings</th>
      <th>View</th>

    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let subscriptionGroup of subscriptionGroupList;">
        <td><a [routerLink]="['/batch/group/show',subscriptionGroup.server_user_id,subscriptionGroup.server_subscription_group_id]">
          {{subscriptionGroup.server_subscription_group_id}}
        </a></td>
        <td>{{subscriptionGroup.name}}</td>
        <td>{{subscriptionGroup.description}}</td>

        <td>{{subscriptionGroup['grouping_count']}}</td>
        <td>
          <a [routerLink]="['/batch/group/show',subscriptionGroup.server_user_id,subscriptionGroup.server_subscription_group_id]" class="me-2">
            <i class="fa fa-eye"></i>
          </a>
          <a [routerLink]="['/batch/group/edit',subscriptionGroup.server_user_id,subscriptionGroup.server_subscription_group_id]">
            <i class="fa fa-edit"></i>
         </a>
        </td>
    </tr>
  </tbody>
  </table>
  </div>
